'use client'

import { TemplateChatAttach } from '@/components/email-detail/template-chat-attach'

/** The chip key a flow attaches under — a namespace of its own, never an email id. */
export function flowRemixChipId(slug: string): string {
  return `flow:${slug}`
}

export type FlowChatAttachProps = {
  slug: string
  title: string
  /** The first step's card, as the chip's thumbnail. */
  imagePngUrl: string | null
  /** "5 emails in 14 days". */
  subtitle?: string
  /** The first step cards, fanned out as a deck on the chip. */
  thumbnails?: ReadonlyArray<string>
}

/**
 * The signed-in flow page's remix entry: the flow attaches to the side
 * chat exactly the way a template does — a chip staged in a new chat,
 * expanded into view, following the user between chats, gone when they
 * leave. `TemplateChatAttach` owns that lifecycle; a flow chip differs only
 * in what it stands for. Its `remixSourceFlowSlug` makes the thread forward
 * the slug as `remixSourceFlowSlug` (REMIX FLOW MODE: the orchestrator loads
 * the flow, builds the automation and rebrands every step) and keeps the
 * chip out of the selected emails, and its key lives in the `flow:`
 * namespace so it can never collide with an email.
 */
export function FlowChatAttach({
  slug,
  title,
  imagePngUrl,
  subtitle,
  thumbnails,
}: FlowChatAttachProps) {
  return (
    <TemplateChatAttach
      emailId={flowRemixChipId(slug)}
      title={title}
      imagePngUrl={imagePngUrl}
      remixSourceFlowSlug={slug}
      subtitle={subtitle}
      thumbnails={thumbnails}
    />
  )
}
